
import s0 from '~/.nuxt/gb-cms/sections/KvalitetaUSluzbiGradana'
import s1 from '~/.nuxt/gb-cms/sections/ListaZnacajki'
import s2 from '~/.nuxt/gb-cms/sections/OrganizacijskeJedinice'
import s3 from '~/.nuxt/gb-cms/sections/OtvorenaPrijava'
import s4 from '~/.nuxt/gb-cms/sections/PrijavaZaPozicijuForma'
import s5 from '~/.nuxt/gb-cms/sections/RadnaMjestaLista'
import s6 from '~/.nuxt/gb-cms/sections/SinglicaSektor'
import s7 from '~/.nuxt/gb-cms/sections/VizijaIMisija'
import s8 from '~/.nuxt/gb-cms/sections/KontaktForma'
import s9 from '~/.nuxt/gb-cms/sections/EuFondoviProjekti'
import s10 from '~/.nuxt/gb-cms/sections/ListaPitanja'
import s11 from '~/.nuxt/gb-cms/sections/BesplatniInfoTelefon'
import s12 from '~/.nuxt/gb-cms/sections/DjelatnostiSlider'
import s13 from '~/.nuxt/gb-cms/sections/HeroSekcija'
import s14 from '~/.nuxt/gb-cms/sections/InformacijeLista'
import s15 from '~/.nuxt/gb-cms/sections/ListaUsluga'
import s16 from '~/.nuxt/gb-cms/sections/MojUnikom'
import s17 from '~/.nuxt/gb-cms/sections/NovostiLista'
import s18 from '~/.nuxt/gb-cms/sections/RadnoVrijemeKarta'
import s19 from '~/.nuxt/gb-cms/sections/PolitikaKvalitete'
import s20 from '~/.nuxt/gb-cms/sections/PravilaPrivatnosti'
import s21 from '~/.nuxt/gb-cms/sections/RasporedOdvoza'
import s22 from '~/.nuxt/gb-cms/sections/NavigacijaIInformacije'

const sectionMapper = {
	'kvaliteta-u-sluzbi-gradana': s0,
	'lista-znacajki': s1,
	'organizacijske-jedinice': s2,
	'otvorena-prijava': s3,
	'prijava-za-poziciju-forma': s4,
	'radna-mjesta-lista': s5,
	'singlica-sektor': s6,
	'vizija-i-misija': s7,
	'kontakt-forma': s8,
	'eu-fondovi-projekti': s9,
	'lista-pitanja': s10,
	'besplatni-info-telefon': s11,
	'djelatnosti-slider': s12,
	'hero-sekcija': s13,
	'informacije-lista': s14,
	'lista-usluga': s15,
	'moj-unikom': s16,
	'novosti-lista': s17,
	'radno-vrijeme-karta': s18,
	'politika-kvalitete': s19,
	'pravila-privatnosti': s20,
	'raspored-odvoza': s21,
	'navigacija-i-informacije': s22
}

export default sectionMapper
